export default __webpack_public_path__ + "static/media/youtube.10673159.svg";